"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createV2 = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../constants");
const helpers_1 = require("./../chat/helpers");
const chat_1 = require("../chat");
function createV2(options) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { signer, spaceName, spaceDescription, listeners, spaceImage, speakers, isPublic, env = constants_1.default.ENV.PROD, pgpPrivateKey = null, rules, config, } = options || {};
        const spaceRules = rules ? (0, helpers_1.convertSpaceRulesToRules)(rules) : null;
        try {
            const group = yield (0, chat_1.createGroupV2)({
                signer,
                groupName: spaceName,
                groupDescription: spaceDescription,
                members: listeners,
                groupImage: spaceImage,
                admins: speakers,
                isPublic: isPublic,
                env,
                pgpPrivateKey,
                groupType: 'spaces',
                config: {
                    meta: null,
                    scheduleAt: config.scheduleAt,
                    scheduleEnd: (_a = config.scheduleEnd) !== null && _a !== void 0 ? _a : null,
                    status: 'PENDING',
                },
                rules: spaceRules,
            });
            return (0, helpers_1.groupInfoDtoToSpaceInfoDto)(group);
        }
        catch (err) {
            console.error(`[Push SDK] - API  - Error - API ${createV2.name} -:  `, err);
            throw new Error(`[Push SDK] - API  - Error - API ${createV2.name} -: ${err}`);
        }
    });
}
exports.createV2 = createV2;
//# sourceMappingURL=createV2.js.map